import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function TabsButtonGroup() {
  const location = useLocation();
  const { t } = useTranslation();

  const tabs = [
    { title: t("type"), path: "types-details" },
    { title: t("group"), path: "group" },
    { title: t("subGroup"), path: "sub-group" },
    { title: t("ledgers"), path: "new-ladger" },
  ];

  return (
    <div>
      <header className="tabs-header pt-2 flex gap-3 px-2 ">
        {tabs.map((tab) => {
      const fullPath = `/account-books/types-groups/${tab.path}`;

      const isActive =
        (location.pathname === "/account-books/types-groups" && tab.path === "types-details") ||
        location.pathname === fullPath;
        

          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`tab no-underline rounded-1 h-7 mt-[2px] pt-[3px] text-sm  px-2 ${isActive
                ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
            >
              {tab.title}
            </Link>
          );
        })}
      </header>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}

export default TabsButtonGroup;
